import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { Box, Column, TextButton, Typography } from 'seagull';
import { getTestIds } from 'seagull/utils/TestIds';
import { AgreementForCustomerSelect } from '~/components/AgreementForCustomerSelect/AgreementForCustomerSelect';
import { useRelationship } from '~/hooks/reactQuery/queries/useRelationship';
import { useLocaleKeys } from '~/i18n';
import BillingHub from '~/pages/AgreementMinisite/BillingHub/BillingHub';
import { getGroupedAgreementOptions } from '~/pages/GlobalBillingHub/GlobalBillingHub.utils';
import { useFetchRelationshipSummaries } from '~/pages/GlobalBillingHub/hooks/useFetchRelationshipSummaries';
import styles from './UpcomingInvoicesTab.module.scss';
export const GetUpcomingInvoicesTabTID = (parentTestId)=>getTestIds(parentTestId);
export function UpcomingInvoicesTab(param) {
    let { clientId, onBillClient } = param;
    var _ref;
    const { UpcomingInvoicesTabTestIds: TID } = useMemo(()=>GetUpcomingInvoicesTabTID(), []);
    const { t: texts } = useLocaleKeys('pages.clientDetail.tabContent.upcomingInvoices');
    const history = useHistory();
    const { summaries } = useFetchRelationshipSummaries({
        refreshOnHookMount: true
    });
    const groupedOptions = useMemo(()=>getGroupedAgreementOptions(summaries, clientId), [
        summaries,
        clientId
    ]);
    const allOptionIds = useMemo(()=>[
            ...groupedOptions.agreements.map((a)=>a.id),
            ...groupedOptions.adHocRelationships.map((a)=>a.id)
        ], [
        groupedOptions
    ]);
    const [selectedId, setSelectedId] = useState(null);
    const effectiveSelectedId = (_ref = selectedId !== null && selectedId !== void 0 ? selectedId : allOptionIds[0]) !== null && _ref !== void 0 ? _ref : null;
    const onAgreementChange = (id)=>{
        setSelectedId(id);
        const params = new URLSearchParams(history.location.search);
        params.delete('selectedDate');
        history.replace({
            search: params.toString()
        });
    };
    if (allOptionIds.length === 0) {
        return /*#__PURE__*/ _jsx(Box, {
            testId: TID.Root(),
            className: styles.root,
            children: /*#__PURE__*/ _jsxs(Column, {
                gap: 16,
                alignItems: "center",
                children: [
                    /*#__PURE__*/ _jsx(Typography, {
                        testId: TID.EmptyNoAgreement(),
                        skin: "secondary",
                        children: texts.emptyNoAgreement()
                    }),
                    /*#__PURE__*/ _jsx(TextButton, {
                        bi: {
                            name: 'client_detail_upcoming_invoices_bill_client'
                        },
                        testId: TID.EmptyNoAgreementCta(),
                        skin: "primary",
                        onClick: onBillClient,
                        children: texts.emptyNoAgreementCta()
                    })
                ]
            })
        });
    }
    if (effectiveSelectedId == null) return null;
    return /*#__PURE__*/ _jsx(Box, {
        testId: TID.Root(),
        className: styles.root,
        children: /*#__PURE__*/ _jsx(BillingHubForAgreement, {
            relationshipId: effectiveSelectedId,
            headerLeftSlot: /*#__PURE__*/ _jsx(AgreementForCustomerSelect, {
                customerId: clientId,
                selectedRelationshipId: effectiveSelectedId,
                onChange: onAgreementChange,
                testId: TID.AgreementSelector(),
                bi: {
                    name: 'client_detail_upcoming_invoices_agreement_selector'
                },
                label: texts.agreementLabel()
            })
        })
    });
}
function BillingHubForAgreement(param) {
    let { relationshipId, headerLeftSlot } = param;
    const { relationship, refresh, isLoading } = useRelationship(relationshipId);
    if (isLoading || relationship == null) return null;
    return /*#__PURE__*/ _jsx(BillingHub, {
        agreement: relationship,
        isVendor: true,
        refreshAgreement: refresh,
        headerLeftSlot: headerLeftSlot,
        inlineHeader: true,
        disableAppcues: true
    }, relationshipId);
}
